import React, { ChangeEventHandler, FC } from "react";
import { formatMessage } from "../../translations/format-message";

// Define the type for the options
interface DropdownOption<T> {
  label: string; // Label displayed to the user
  value: T; // The value associated with the label
}

// Define the props for the generic dropdown component
interface DropdownProps<T> {
  options: DropdownOption<T>[]; // Array of options to display
  onChange: ChangeEventHandler<HTMLSelectElement>; // Function to call when an option is selected
  value: T; // The currently selected value
  placeholder?: string; // Optional placeholder text
  className?: string; // Optional placeholder text
  disabled?: boolean; // Optional placeholder text
}

const DropdownInput = <T,>({
  options,
  onChange,
  value,
  // placeholder = "Select an option",
  className = "",
  disabled = false,
}: DropdownProps<T>) => {
  return (
    <select
      className={className}
      value={value as unknown as number} // Type assertion for generic type
      onChange={onChange}
      disabled={disabled}
    >
      {/* Placeholder option */}
      {/* {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )} */}
      {/* Map through options and render each one */}
      {options.map((option, index) => (
        <option key={index} value={option.value as unknown as number}>
          {formatMessage(option.label)}
        </option>
      ))}
    </select>
  );
};

export default DropdownInput;
